import { render, staticRenderFns } from "./BarraDeFiltro.vue?vue&type=template&id=99a28a26&scoped=true"
import script from "./BarraDeFiltro.vue?vue&type=script&lang=js"
export * from "./BarraDeFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a28a26",
  null
  
)

export default component.exports